/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import Editor from "@monaco-editor/react";
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../../components/Cards/Card";
import { getDomainBrandIdentity } from "../../../../../store/actions/domain-brand.action";
import { fetchAppLanguage } from "../../../../../utils/helpers/logicHelper";
import { fetchSubDomain } from "../../../../../utils/services/baseUrl";
import { ManagerService } from "../../../../../utils/services/manager.service";

function Css({ dictionary, domainBrand }) {
  const dispatch = useDispatch();
  const subdomain = fetchSubDomain();
  const selectedLanguage = fetchAppLanguage();
  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cssContent, setCssContent] = useState(false);
  const [cssValue, setCssValue] = useState(domainBrand?.domainBrand?.css);

  const handleEditorChange = (value, event) => {
    setCssValue(value);
  };

  const updateBrandSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.updateBrandSettings(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(getDomainBrandIdentity(subdomain, selectedLanguage["id"]));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setCssContent(!cssContent)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {cssContent ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary
              ? dictionary["WO_CSS_CONTEN_-302230146"]
              : "CSS CONTENT"}
          </li>

          <Collapse in={cssContent}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {/* {dictionary
                  ? dictionary["para_enable_or_disable_the_circle_login..."]
                  : `Please paste css content blow`} */}
                Please paste css content below
              </h6>
              <div className="form-row py-4">
                <div className="col-lg-12 col-md-12 mb-3">
                  <Editor
                    height="50vh"
                    defaultLanguage={"CSS"}
                    defaultValue={cssContent}
                    onChange={handleEditorChange}
                    className="monaco"
                    // value={value}
                  />
                </div>
                <div className="col-lg-6 col-md-6" />
                <div className="col-lg-6 col-md-6">
                  <button
                    onClick={() => updateBrandSettings({ css: cssValue })}
                    className="login100-form-btn btn-primary fw-bold text-uppercase float-end"
                  >
                    {dictionary ? dictionary["WO_SAVE_-91866246"] : "SAVE"}
                    &nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default Css;
